import React from 'react';

const NewUserRegistration = () => {
  return <div>test</div>;
};

export default NewUserRegistration;
